import { HgSupportedLanguage } from '@smg-real-estate/domus';
import { type RouteLocationNormalizedGeneric } from 'vue-router';

import auth0 from '@/auth/auth0Plugin';
import { isEmailWhitelisted } from '@/helpers/validations';
import { LOGIN_LOCATION } from '@/services/tracking/GtmTrackingService';
import { useNavigationStore } from '@/stores/navigation';
import { type AuthorizedUser, type UserRedirectedNextStep } from '@/types';

export function isUnsupportedBrowser(): boolean {
  return /^.*((MSIE(?!\s11))+|(Trident\/[0-6]+)).*/i.test(navigator.userAgent);
}

export function goToLogin(
  toRoute: RouteLocationNormalizedGeneric,
  locale: HgSupportedLanguage,
  additionalParams?: UserRedirectedNextStep,
  login_hint?: string,
) {
  const navigationStore = useNavigationStore();
  navigationStore.redirectingToExternal = true;
  auth0.loginWithRedirect({
    appState: {
      targetPath: toRoute.fullPath,
      ...additionalParams,
    },
    authorizationParams: {
      ui_locales: locale,
      login_hint: login_hint,
      referring_feature: LOGIN_LOCATION,
      referral_url: typeof window !== 'undefined' ? window.location.href : '',
    },
  });
}

export function shouldRedirectToEmailVerification(user: AuthorizedUser) {
  // exclude whitelisted emails on test environment
  if (import.meta.env.VUE_APP_STAGE === 'test' && isEmailWhitelisted(user.email)) return false;
  return !user.emailVerified;
}
